import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SmoothScroll from './components/SmoothScroll';
import Home from './pages/Home';
import About from './features/About/About';
import Services from './pages/Services';
import Calculator from './pages/Calculator';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen overflow-x-hidden bg-gray-100 text-gray-900">
        <Navbar />
        <SmoothScroll>
          <section id="home" className="min-h-screen py-16 px-4 md:px-8">
            <Home />
          </section>
          <section id="about" className="min-h-screen py-16 px-4 md:px-8 bg-gray-200">
            <About />
          </section>
          <section id="services" className="min-h-screen py-16 px-4 md:px-8">
            <Services />
          </section>
          <section id="calculator" className="min-h-screen py-16 px-4 md:px-8 bg-gray-200">
            <Calculator />
          </section>
          <section id="contact" className="min-h-screen py-16 px-4 md:px-8 bg-gray-200">
            <Contact />
          </section>
        </SmoothScroll>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
